export const instrumentationFilterTypes = {
    FilterByGroups: "FilterByGroups",
    FilterByMembers: "FilterByMembers",
    FilterByGroupsAndMembers: "FilterByGroupsAndMembers"
};